import { TEDParseDefault } from '../Parsers/TEDParserDefault';
import { TEDValidateDefault } from '../Validators/TEDValidateDefault';
import { TEDDisplayDefault } from '../Displayers/TEDDisplayDefault';
import { IFormatter } from '../FormatterTypes';
import { ClientAttributeDataType } from '../../../Types/ClientModelTypes';
import { TEDDisplayBool } from '../Displayers/TEDDisplayBool';
import { TEDDisplayCurr } from '../Displayers/TEDDisplayCurr';
import { TEDDisplayDate } from '../Displayers/TEDDisplayDate';
import { TEDDisplayDateTime } from '../Displayers/TEDDisplayDateTime';
import { TEDDisplayFloat } from '../Displayers/TEDDisplayFloat';
import { TEDDisplayInt } from '../Displayers/TEDDisplayInt';
import { TEDDisplayTime } from '../Displayers/TEDDisplayTime';
import { TEDParseBool } from '../Parsers/TEDParseBool';
import { TEDParseCurr } from '../Parsers/TEDParseCurr';
import { TEDParseDate } from '../Parsers/TEDParseDate';
import { TEDParseFloat } from '../Parsers/TEDParseFloat';
import { TEDParseInt } from '../Parsers/TEDParseInt';
import { TEDValidateDate } from '../Validators/TEDValidateDate';
import { BaseDisplayer } from '../Displayers/BaseDisplayer';
import { BaseParser } from '../Parsers/BaseParser';
import { BaseValidator } from '../Validators/BaseValidator';

class TEDFormatDefault implements IFormatter {
  displayer: BaseDisplayer;
  parser: BaseParser;
  validator: BaseValidator;
  constructor(dataType?: ClientAttributeDataType) {
    this.displayer = this.getDisplayer(dataType).getInstance();
    this.parser = this.getParser(dataType).getInstance();
    this.validator = this.getValidator(dataType).getInstance();
  }

  getDisplayer(dataType?: ClientAttributeDataType) {
    switch (dataType) {
      case 'Boolean':
        return TEDDisplayBool;
      case 'Currency':
        return TEDDisplayCurr;
      case 'Date':
        return TEDDisplayDate;
      case 'DateTime':
        return TEDDisplayDateTime;
      case 'Float':
        return TEDDisplayFloat;
      case 'Int':
        return TEDDisplayInt;
      case 'Time':
        return TEDDisplayTime;
      default:
        return TEDDisplayDefault;
    }
  }

  getParser(dataType?: ClientAttributeDataType) {
    switch (dataType) {
      case 'Boolean':
        return TEDParseBool;
      case 'Currency':
        return TEDParseCurr;
      case 'Date':
      case 'DateTime':
        return TEDParseDate;
      case 'Float':
        return TEDParseFloat;
      case 'Int':
        return TEDParseInt;
      default:
        return TEDParseDefault;
    }
  }

  getValidator(dataType?: ClientAttributeDataType) {
    switch (dataType) {
      case 'Date':
      case 'DateTime':
        return TEDValidateDate;
      default:
        return TEDValidateDefault;
    }
  }
}

export { TEDFormatDefault };
